export enum ItemLabelFilterType {
  Free = 0,
  Specific = 1,
}

export enum ItemLabelOrderColumnsLabel {
  Barcode = 0,
  ManufacturingCode = 1,
  Manufacturer = 2,
  Description = 3,
  Sku = 4,
  CompanyCode = 5,
}

export enum ItemLabelOrder {
  ASC = 0,
  DESC = 1,
}

export interface ItemLabelRequest {
  companyId?: number;
  barcode?: string;
  sku?: string;
  manufacturingCode?: string;
  manufacturerId?: number;
  companyCode?: string;
  description?: string;
  subGroupId?: number;
  location?: string;
  search?: string;
  active?: boolean;
  filterType?: ItemLabelFilterType;
  orderColumns?: ItemLabelOrderColumnsLabel;
  pageSize?: number;
  page?: number;
  order?: ItemLabelOrder;
}

export interface ItemLabel {
  partId: number;
  barcode: string;
  sku: string;
  manufacturingCode: string | null;
  companyCode: string | null;
  description: string;
  imageUrl: string | null;
  price: {
    cost: number;
    sellPrice: number;
    realCost: number;
    location: string | null;
  };
}

export interface ItemLabelResponse {
  error?: {
    name: string;
    description: string;
    fieldErrors: {
      internalSource: Record<string, string[]>;
    };
  };
  result?: {
    page: number;
    pageSize: number;
    totalRecords: number;
    totalPages: number;
    data: ItemLabel[];
  };
}
